if (!customElements.get('kex-video-circles')) {
  class KexVideoCircles extends HTMLElement {
    connectedCallback() {
      this.modal = document.getElementById(this.dataset.modal);
      this.player = this.modal ? this.modal.querySelector('.kex-video-modal__player') : null;
      this.circleVideos = Array.from(this.querySelectorAll('video[data-src]'));

      // Lazy-load and autoplay (muted) the circles only while visible.
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (!video.getAttribute('src')) video.src = video.dataset.src;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '120px' });

      this.circleVideos.forEach((video) => this.observer.observe(video));

      this.addEventListener('click', (evt) => {
        const btn = evt.target.closest('[data-kex-video]');
        if (!btn || !this.modal || !this.player) return;

        this.player.src = btn.dataset.kexVideo;
        if (btn.dataset.kexPoster) this.player.poster = btn.dataset.kexPoster;
        this.modal.open(btn);
        this.player.play().catch(() => {});
      });

      if (this.modal && this.player) {
        // When the modal closes (attribute removed), stop playback and
        // resume the visible circles.
        new MutationObserver(() => {
          if (this.modal.hasAttribute('open')) return;
          this.player.pause();
          this.player.removeAttribute('src');
          this.player.load();
          this.circleVideos.forEach((video) => {
            this.observer.unobserve(video);
            this.observer.observe(video);
          });
        }).observe(this.modal, { attributes: true, attributeFilter: ['open'] });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('kex-video-circles', KexVideoCircles);
}
